/**
 * Created by vladislav on 10.02.2022
 */

const DailyCupView = cc.Node.extend({
    ctor: function () {
        this._super();

        const styles = cleverapps.styles.DailyCupView;

        const title = this.createTitle();
        const timerBlock = this.timerBlock = new CupTimer({
            timeLeft: cleverapps.dailyCup.getTimeLeft(),
            text: Messages.get("Cups.daily.finished")
        });
        const table = this.createTable();

        const topLayout = new cleverapps.Layout([title, timerBlock, table], {
            margin: styles.topLayout.margin,
            direction: cleverapps.UI.VERTICAL
        });

        const helpButton = this.createHelpButton();
        const leadersButton = this.createLeadersButton();
        const playButton = this.playButton = this.createPlayButton();

        this.buttonsLayout = new cleverapps.Layout([helpButton, playButton, leadersButton], {
            margin: styles.buttonsLayout.margin,
            direction: cleverapps.UI.HORIZONTAL
        });

        const buttonsControl = new cc.Node();
        buttonsControl.addChild(this.buttonsLayout);

        ComponentMap.attach(buttonsControl, new HidingComponent({
            direction: cleverapps.UI.VERTICAL,
            control: "dailyCupButtons"
        }));

        const layout = new cleverapps.Layout([topLayout, buttonsControl], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(layout.width, layout.height);
        layout.setAlignment(this.width / 2, this.height / 2);
        this.addChild(layout);

        const noConnectionInfo = this.noConnectionInfo = this.createNoConnectionInfo();
        noConnectionInfo.setAlignment(layout.width / 2, layout.height / 2);
        layout.addChild(noConnectionInfo, 1);

        this.updateState();

        cleverapps.dailyCup.reload();

        cleverapps.dailyCup.on("update", this.createListener(this.updateState.bind(this)), this);

        this.onResize();
    },

    onResize: function () {
        const styles = cleverapps.styles.DailyCupView;
        const sceneWidth = cleverapps.resolution.getSceneSize().width;

        this.setScale(Math.min(sceneWidth / this.width * 0.95, 1));

        this.setAlignment(styles.position);
    },

    updateState: function () {
        if (this.animationRunning) {
            return;
        }

        if (cleverapps.dailyCup.isRunning()) {
            this.timerBlock.showTimer(cleverapps.dailyCup.getTimeLeft());

            this.playButton.setString(Messages.get("Play"));
            this.playButton.enable();
        } else {
            this.timerBlock.showText();

            if (cleverapps.dailyCup.getReward()) {
                this.playButton.setString(Messages.get("Claim"));
                this.playButton.enable();
            } else if (cleverapps.dailyCup.isActive() && cleverapps.dailyCup.isFinished()) {
                this.playButton.setString(Messages.get("Next"));
                this.playButton.enable();
            } else {
                this.playButton.setString(Messages.get("Play"));
                this.playButton.disable();
            }
        }

        if (cleverapps.dailyCup.hasConnection()) {
            this.noConnectionInfo.setVisible(false);
        } else {
            this.noConnectionInfo.setVisible(true);
            this.playButton.disable();
        }
    },

    createTitle: function () {
        const styles = cleverapps.styles.DailyCupView.title;

        const titleNode = new cc.Node();
        titleNode.setAnchorPoint(0.5, 0.5);
        titleNode.setContentSize2(styles);

        const titleBg = new cc.Scale9Sprite(bundles.daily_cup.frames.daily_cup_title_bg_png);
        titleBg.setContentSize2(styles);

        titleNode.addChild(titleBg);
        titleBg.setAlignment(styles.bg);

        const title = cleverapps.UI.generateOnlyText(Messages.get("Cups.daily.title"), cleverapps.styles.FONTS.DAILY_CUP_TITLE_TEXT);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);
        title.fitTo(styles.text.width);
        titleNode.addChild(title);
        title.setAlignment(styles.text);

        return titleNode;
    },

    createTable: function () {
        return new CupTableView(cleverapps.dailyCup, (() => {
            const view = new cleverapps.UI.ScrollView(new cc.Node(), {
                scrollBarEnabled: !cleverapps.dailyCup.table.scrollDisabled,
                mouseScroll: !cleverapps.dailyCup.table.scrollDisabled,
                dock: true
            });

            new TableHandler(cleverapps.dailyCup.table, view, {
                id: cleverapps.dailyCup.type,
                bg: bundles.table.frames.table_bg_png,
                rowOptions: {
                    dataIcon: bundles.tablerow_icons.frames.dailycup,
                    dynamicWidth: true
                },
                height: cleverapps.styles.DailyCupView.height
            });
                
            return view;
        }));
    },

    createHelpButton: function () {
        return new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_light,
            callback: function () {
                cleverapps.focusManager.display({
                    focus: "DailyCupRulesWindow",
                    action: function (f) {
                        new GuideWindow({
                            name: "DailyCupRulesWindow",
                            bundle: bundles.dailycupruleswindow
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            } 
        });
    },

    createPlayButton: function () {
        const styles = cleverapps.styles.DailyCupView;

        return new cleverapps.UI.Button({
            text: Messages.get("Play"),
            width: styles.playButton.width,
            height: styles.playButton.height,
            onClicked: function () {
                if (this.animationRunning) {
                    return;
                }

                cleverapps.focusManager.display({
                    focus: "PlayDailyCup",
                    actions: [
                        function (f) {
                            this.animationRunning = true;

                            if (cleverapps.dailyCup.isRunning()) {
                                cleverapps.dailyCup.wantsToPlay(f);
                            } else if (cleverapps.dailyCup.getReward()) {
                                cleverapps.dailyCup.receiveReward(f);
                            } else if (cleverapps.dailyCup.isActive() && cleverapps.dailyCup.isFinished()) {
                                cleverapps.dailyCup.next();
                                f();
                            } else {
                                f();
                            }
                        }.bind(this),

                        function (f) {
                            f();
                            this.animationRunning = false;
                            this.updateState();
                        }.bind(this)
                    ]
                });
            }.bind(this)
        });
    },

    createLeadersButton: function () {
        const styles = cleverapps.styles.DailyCupView;

        const leadersButton = new cc.Sprite(bundles.daily_cup.frames.daily_cup_leaders_icon_png);
        cleverapps.UI.fitToBox(leadersButton, styles.leadersButton);
        leadersButton.baseScale = leadersButton.scale;

        cleverapps.UI.applyHover(leadersButton);
        cleverapps.UI.onClick(leadersButton, () => {
            cleverapps.focusManager.display({
                focus: "DailyCupLeadersWindow",
                action: function (f) {
                    new DailyCupLeadersWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        });

        return leadersButton;
    },

    createNoConnectionInfo: function () {
        const styles = cleverapps.styles.DailyCupView.noConnectionInfo;

        const background = new cc.Scale9Sprite(bundles.small_timer.frames.small_timer_bg_png);
        background.setContentSize2(styles.bg);

        const text = cleverapps.UI.generateOnlyText(Messages.get("InternetConnectionError"), cleverapps.styles.FONTS.WHITE_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setAlignment(background.width / 2, background.height / 2);
        text.setDimensions(background.width, background.height);
        background.addChild(text);

        return background;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DAILY_CUP_TITLE_TEXT: {
        name: "default",
        color: cleverapps.styles.COLORS.WHITE,
        size: 60,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.DailyCupView = {
    height: 640,
    margin: 40,

    position: {
        x: { align: "center" },
        y: { align: "center", dy: -30 }
    },

    topLayout: {
        margin: 20
    },

    title: {
        width: 500,
        height: 150,

        bg: {
            x: { align: "center" },
            y: { align: "center", dy: -30 }
        },

        text: {
            width: 250,

            x: { align: "center" },
            y: { align: "center", dy: -10 }
        }
    },

    table: {
        height: 650,

        paddingX: 20
    },

    buttonsLayout: {
        margin: 20
    },

    playButton: {
        width: 300,
        height: 125
    },

    leadersButton: {
        width: 100,
        height: 100
    },

    noConnectionInfo: {
        bg: {
            width: 480,
            height: 120
        }
    }
};
